import React, { useEffect, useRef, useState } from "react";
import type { NavBarProps } from "./desktop/types/navigation";
import NavBarContentDesktop from "./desktop/components/NavBarContentDesktop";
import NavBarContentMobile from "./mobile/components/NavBarContentMobile";

const InspirationNavBar: React.FC<NavBarProps> = (props) => {
  const prevScrollRef = useRef(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setVisible(prevScrollRef.current > currentScrollPos || currentScrollPos < 30);
      prevScrollRef.current = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed left-0 right-0 top-[10px] z-50 flex h-auto w-screen items-center justify-center bg-transparent transition-transform duration-500 ${
        visible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <NavBarContentDesktop {...props} />
      <NavBarContentMobile {...props} />
    </nav>
  );
};

export default InspirationNavBar;
